import { useState, useEffect, useRef, useCallback } from 'react'
import { RefreshCw, X } from 'lucide-react'

// Detecta nova versão publicada (mesmo com a aba aberta há horas) e oferece atualizar.
// Compara o bundle carregado com o do index.html atual (buscado sem cache).
function bundleCarregado() {
  const s = [...document.querySelectorAll('script')].map((x) => x.src).find((x) => /\/assets\/index-.*\.js/.test(x))
  const m = s && s.match(/index-[\w-]+\.js/)
  return m ? m[0] : null
}

export default function AtualizacaoDisponivel() {
  const [nova, setNova] = useState(false)
  const [fechado, setFechado] = useState(false)
  const atual = useRef(bundleCarregado())

  const checar = useCallback(async () => {
    if (!atual.current) return
    try {
      const r = await fetch('/?_=' + Date.now(), { cache: 'no-store' })
      const html = await r.text()
      const m = html.match(/index-[\w-]+\.js/)
      if (m && m[0] !== atual.current) setNova(true)
    } catch { /* offline — tenta na próxima */ }
  }, [])

  useEffect(() => {
    const id = setInterval(checar, 180000) // a cada 3 min
    const onVis = () => { if (document.visibilityState === 'visible') checar() }
    document.addEventListener('visibilitychange', onVis)
    window.addEventListener('focus', onVis)
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVis); window.removeEventListener('focus', onVis) }
  }, [checar])

  if (!nova || fechado) return null
  const atualizar = () => window.location.replace(window.location.pathname + '?v=' + Date.now() + window.location.hash)

  return (
    <div style={{ position: 'fixed', bottom: 18, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}
      className="bg-graphite text-white rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 text-sm max-w-[92vw]">
      <RefreshCw size={16} className="text-accent-400 flex-shrink-0" />
      <span>Uma <b>nova versão</b> do sistema está disponível.</span>
      <button onClick={atualizar} className="font-bold rounded-lg px-3 py-1.5 text-graphite whitespace-nowrap"
        style={{ background: 'linear-gradient(135deg,#ffcc00,#ff6c00)' }}>Atualizar agora</button>
      <button onClick={() => setFechado(true)} className="text-neutral-400 hover:text-white"><X size={16} /></button>
    </div>
  )
}
